import { render, staticRenderFns } from "./BaseMessageBox.vue?vue&type=template&id=b935ea9c&scoped=true"
import script from "./BaseMessageBox.vue?vue&type=script&lang=js"
export * from "./BaseMessageBox.vue?vue&type=script&lang=js"
import style0 from "./BaseMessageBox.vue?vue&type=style&index=0&id=b935ea9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b935ea9c",
  null
  
)

export default component.exports